import React from 'react';
import { Icon } from './style';

const IconBigDownload = () => (
  <Icon className="icon-download3">
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
      <span className="path4"></span>
      <span className="path5"></span>
  </Icon>
);

export default IconBigDownload;
